import  React  from "react";
import { Helmet } from 'react-helmet';
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-awesome-slider/dist/styles.css';
import Footer from "./Footer";
import Header from "./Header";
import ScrollAnimation from 'react-animate-on-scroll';
import ConsultationForm from "./components/ConsultationForm";

class contact extends React.Component {
    render() {

        const myStyleone = {
            backgroundImage:
                "url('../assets/img/bg/choose-us-bg-2.jpg')",
            width: "100%",
            zIndex: 2,
        };
        const mystyletow = {
        backgroundColor: "#FFF"
        };
        return (
            <div>
                <Helmet>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/jquery-datetimepicker/2.5.20/jquery.datetimepicker.min.css"/>
                    <link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css" />                    
                    <script src="https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js"></script>
                    <script src="../assets/js/script.js" type="Javascript"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-datetimepicker/2.5.20/jquery.datetimepicker.full.min.js"></script>                    
                </Helmet>
                {/* <div className="loader" ><span>Loading...</span></div> */}
                <Header />
                <div className="breadcumb-wrapper" style={myStyleone}>
                    <div className="container">
                        <div className="breadcumb-content">
                            <h1 className="breadcumb-title mb-20">Get In Touch</h1>
                            <p className="text-white">Get a quote, or speak with an expert? Let us know what you are looking for and we’ll get back to you right away</p>                           
                        </div>
                    </div>
                </div>
               
                <div className="bg-smoke" style={mystyletow}>
                    <div className="container-fluied">
                        <div className="row">
                            <div className="col-xl-6 ctn-from">
                                <div className="title-area mb-35 text-xl-start text-center">
                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                    <span className="sub-title"><img
                                    src="../assets/img/theme-img/title_shape_2.svg" alt="shape" />contact with us!</span>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                    <h2 className="sec-title">Drop Us a Line</h2>
                                </ScrollAnimation>  
                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                    <p className="sec-text">Reach Out to us from our Contact form and we will get back to you shortly.</p>
                                </ScrollAnimation>
                                </div>
                                <ConsultationForm
                                    className="contact-forms"
                                    subjectInput
                                    defaultSubject="ContactUs"
                                    defaultTodayDate
                                    buttonClassName="as-btn style3"
                                    buttonText="Send Details"
                                />
                            </div>
                            <div className="col-xl-6 ps-0">
                            <div className="map-sec" >
                                <iframe title="OENGINES Games LLP location map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d276.2593411090248!2d72.85847216407258!3d21.235272708671435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f153fc63919%3A0x825cef8b1bee1265!2sOENGINES%20GAMES%20LLP!5e0!3m2!1sen!2sin!4v1679640277224!5m2!1sen!2sin" allowFullScreen="" loading="lazy"></iframe></div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
               
            </div>
        )
    }
}

export default contact;
    
